// ExpiryBanner.jsx
// Shows a quiet, non-intrusive banner when the client's access is within 3 days of expiring.
// Mount once, high up, only on client-facing (gated) pages.

import React from "react";
import { getClientExpiryDate, isClientLoggedIn } from "./clientApi";
import "./ExpiryBanner.css";

export default function ExpiryBanner() {
  if (!isClientLoggedIn()) return null;

  const expiresAt = getClientExpiryDate();
  if (!expiresAt) return null;

  const daysLeft = (expiresAt - new Date()) / (1000 * 60 * 60 * 24);
  if (daysLeft > 3 || daysLeft < 0) return null; // only show in that final 3-day window

  const roundedDays = Math.max(1, Math.ceil(daysLeft));

  return (
    <div className="expiry-banner">
      Your access to this portfolio expires in {roundedDays} day{roundedDays === 1 ? "" : "s"}.
      Contact Eilan Digital if you'd like it extended.
    </div>
  );
}
